export default {"src":"/_next/static/media/drone_24.ff914e39.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};